import React from 'react'
import cn from 'classnames'
import { useVehicle } from 'api'
import { Booking as BookingT } from 'api/types'
import { VehicleCount } from 'components'
import { translateStatus } from 'utils/translateStatus'
import { formatDate, formatDistanceDays } from 'utils/format'
import { useTranslation } from 'react-i18next'
import classes from './BookingHeader.module.scss'

interface BookingHeaderProps {
  booking: BookingT
}

export const BookingHeader: React.FunctionComponent<BookingHeaderProps> = ({
  booking,
}) => {
  const { data: vehicle } = useVehicle(booking.vehicleId)
  const { t } = useTranslation()

  return (
    <div className={classes.header}>
      <div className={cn(classes.item, classes.status)}>
        <div
          className={cn(classes.statusIcon, {
            [classes.sending]: booking.status === 'SENDING',
            [classes.sent]: booking.status === 'SENT',
            [classes.approved]: booking.status === 'APPROVED',
            [classes.cancelled]: booking.status === 'CANCELLED',
            [classes.started]: booking.status === 'STARTED',
            [classes.finished]: booking.status === 'FINISHED',
            [classes.finished]: booking.status === 'CANCELLING',
          })}
        ></div>
        <div className={`${cn(classes.statusLabel)} booking-status`}>
          {t(translateStatus(booking.status))}
        </div>
      </div>
      <div className={cn(classes.item, classes.orderNumber)}>
        {booking.orderNumber}
      </div>
      <div className={cn(classes.item, classes.duration)}>
        {formatDate(booking.startDate)} (
        {formatDistanceDays(booking.startDate, booking.endDate)})
      </div>
      <div className={cn(classes.item, classes.vehicle)}>
        <VehicleCount
          count={booking.vehicleCount}
          vehicleGroup={vehicle?.group}
        />
      </div>
    </div>
  )
}
